"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCK = void 0;
const vue_1 = __importDefault(require("vue"));
const types_1 = require("./types");
const cell_editor_1 = require("./cell-editor");
const cell_formatter_1 = require("./cell-formatter");
const LOCK_FORMATTER_CONFIG = types_1.BASE_CONFIG.extend({});
const LOCK_EDITOR_CONFIG = types_1.BASE_CONFIG.extend({});
exports.LOCK = {
    name: 'lock',
    sortable: false,
    headerIcon: 'lock',
    formatter: {
        schema: LOCK_FORMATTER_CONFIG,
        createComponent(config) {
            return {
                component: {
                    name: 'LockFormatter',
                    mixins: [cell_formatter_1.CellFormatter],
                    ...vue_1.default.compile(`<div><ItpIcon v-if="value" name="fa-lock"></ItpIcon></div>`)
                }
            };
        }
    },
    editor: {
        schema: LOCK_EDITOR_CONFIG,
        createComponent(config) {
            return {
                component: {
                    name: 'LockEditor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<div>
              <ItpButton
                v-if="!value"
                size="sm"
                variant="default"
                @click="col.emitCellEvent('lock', row)"
              >
                {{ 'Lock'|pgettext('DataTableRow') }}
              </ItpButton>
            </div>`)
                }
            };
        }
    }
};
//# sourceMappingURL=lock.js.map